import { render, staticRenderFns } from "./delete-review-modal.vue?vue&type=template&id=3d4d4afe&"
import script from "./delete-review-modal.vue?vue&type=script&lang=ts&"
export * from "./delete-review-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports